import { type FC } from 'react';
import { IconButton } from '@mui/material';
import { Menu } from '@mui/icons-material';
import { OmitDeep } from 'type-fest';

import { PageHeader, type PageHeaderProps } from './page-header';

export type MainPageHeaderProps = OmitDeep<
  PageHeaderProps,
  'navigationIcon'
> & {
  /**
   * Handler for app menu click
   */
  onNavigationIconClick: () => void;
};

export const MainPageHeader: FC<MainPageHeaderProps> = ({
  onNavigationIconClick,
  ...props
}) => (
  <PageHeader
    navigationIcon={
      <IconButton
        color="inherit"
        aria-label="menu"
        onClick={onNavigationIconClick}
        edge="start"
        sx={{ mr: 0.5 }}>
        <Menu fontSize="large" />
      </IconButton>
    }
    {...props}
  />
);
